<template>
  <div>
    <button
        @click="isOpen = !isOpen"
        class="w-full flex font-bold font-sans text-lg text-blue-700 flex justify-between items-center py-4 cursor-pointer border-t-2 border-grey-200 active:outline-none focus:outline-none"
    >
      <span class="w-11/12 text-left">
          {{ title }}
      </span>
      <svg
          xmlns="http://www.w3.org/2000/svg"
          class="fill-current text-blue-700 w-5 h-5"
          viewBox="0 0 20 20"
          v-if="!isOpen"
      >
        <path d="M11 9h4v2h-4v4H9v-4H5V9h4V5h2v4zm-1 11a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"/>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
           class="fill-current text-blue-700 w-5 h-5"
           v-if="isOpen"
      >
        <path d="M140 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H140zm364-28c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-48 0c0-110.5-89.5-200-200-200S56 145.5 56 256s89.5 200 200 200 200-89.5 200-200z"/>
      </svg>

    </button>
    <div class="panelx" v-if="isOpen">
      <p>
        <slot></slot>
      </p>
    </div>
  </div>

</template>

<script>
export default {
  name: "Accordion",
  props: ['title'],
  data: function() {
    return {
      isOpen: false
    };
  }
};
</script>

<style scoped>

</style>